module.exports = __webpack_public_path__ + "img/home-lifestyle-s.c72f28ca.jpg";